import Vue from "vue";
import App from "@/App.vue";
import store from "@/flit2go-web-core/store";
import router from "@/base/router";
import i18n from "@/flit2go-web-core/lang/";
import service from "@/flit2go-web-core/services/";
//import "vuetify/src/stylus/app.styl";
import Vuetify, {
  VApp,
  VMain,
  VContainer,
  VFlex,
  VLayout,
  VToolbar,
  VToolbarItems,
  VToolbarTitle,
  VMenu,
  VListGroup,
  VList,
  VListItem,
  VListItemTitle,
  VDataTable,
  VSkeletonLoader,
  VDatePicker,
  VTextarea,
  VTimePicker,
  VBadge,
  VStepper,
  VStepperStep,
  VStepperItems,
  VStepperHeader,
  VStepperContent,
  VPagination,
  VTabs,
  VTab,
  VTabItem,
  VTabsItems,
  VListItemAvatar,
  VExpansionPanels,
  VExpansionPanel,
  VExpansionPanelHeader,
  VExpansionPanelContent,
  VCard,
  VCardTitle,
  VCardText,
  VCardActions,
  VCarousel,
  VCarouselItem,
  VCalendar,
  VDialog,
  VAlert,
  VImg,
  VInput,
  VTextField,
  VAutocomplete,
  VDivider,
  VListItemSubtitle,
  VListItemAction,
  VListItemContent,
  VBtn,
  VProgressCircular,
  VSelect,
  VSnackbar,
  VSubheader,
  VAvatar,
  VChip,
  VSwitch,
  VTooltip,
  VCheckbox,
  VRadioGroup,
  VBottomSheet,
  VRadio,
  VIcon,
  VResponsive,
  VProgressLinear,
  VSpacer,
  VBtnToggle,
  VRating,
  VCombobox,
  VBreadcrumbs,
  VBreadcrumbsItem,
} from "vuetify/lib";
import "vuetify/src/styles/main.sass";
import Vuelidate from "vuelidate";
import VueObserveVisibility from "vue-observe-visibility";
import { Scroll } from "vuetify/lib/directives";
import _ from "lodash";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import VueGtag from "vue-gtag";
import "@/registerServiceWorker";
import "@/flit2go-web-core/plugins/global-components.js";
import Constants from "@/flit2go-web-core/interfaces/index.js";
import PageUtils from "@/flit2go-web-core/util/paginationUtil.js";
import VueTheMask from "vue-the-mask";
import Ripple from "vuetify/lib/directives/ripple";

if (process.env.VUE_APP_MODE === "production") {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY,
    environment: process.env.VUE_APP_MODE,
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ["localhost", "my-site-url.com", /^\//],
      }),
    ],
    tracesSampleRate: 1.0,
  });
} else {
  // eslint-disable-next-line
  console.log("Not showing Sentry, environment is", process.env.VUE_APP_MODE);
}

Vue.prototype.$PageUtils = PageUtils;
Vue.prototype.$service = service;
Vue.config.productionTip = false;

if (process.env.NODE_ENV === "production") {
  // Configuration VueAnalytics

  Vue.use(
    VueGtag,
    {
      config: { id: process.env.VUE_APP_ANALYTICS_ID },
      params: {
        send_page_view: true,
      },
    },
    router
  );
}

/*
    config: { id: "UA-1234567-1" }
    id: process.env.VUE_APP_ANALYTICS_ID,
    router
  });
 */

Vue.use(VueObserveVisibility);
Vue.use(Vuelidate);
Vue.use(VueTheMask);
Vue.use(Vuetify, {
  components: {
    VApp,
    VMain,
    VContainer,
    VFlex,
    VLayout,
    VToolbar,
    VToolbarItems,
    VToolbarTitle,
    VMenu,
    VListGroup,
    VList,
    VListItem,
    VListItemTitle,
    VDataTable,
    VSkeletonLoader,
    VDatePicker,
    VTextarea,
    VTimePicker,
    VBadge,
    VStepper,
    VStepperStep,
    VStepperItems,
    VStepperHeader,
    VStepperContent,
    VPagination,
    VTabs,
    VTab,
    VTabItem,
    VTabsItems,
    VListItemAvatar,
    VExpansionPanels,
    VExpansionPanel,
    VExpansionPanelHeader,
    VExpansionPanelContent,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions,
    VCarousel,
    VCarouselItem,
    VCalendar,
    VDialog,
    VAlert,
    VImg,
    VInput,
    VTextField,
    VAutocomplete,
    VDivider,
    VListItemSubtitle,
    VListItemAction,
    VListItemContent,
    VBtn,
    VProgressCircular,
    VSelect,
    VSnackbar,
    VSubheader,
    VAvatar,
    VChip,
    VSwitch,
    VTooltip,
    VCheckbox,
    VRadioGroup,
    VBottomSheet,
    VRadio,
    VIcon,
    VResponsive,
    VProgressLinear,
    VSpacer,
    VBtnToggle,
    VRating,
    VCombobox,
    VBreadcrumbs,
    VBreadcrumbsItem,
  },
  directives: { Scroll, Ripple },
});

export default new Vuetify({
  icons: {
    iconfont: "md",
    theme: {
      primary: "#1c8523",
      secondary: "#b0bec5",
      accent: "#8c9eff",
      error: "#b71c1c",
      blueVolvo: "#1976d2",
    },
  },
});

Vue.prototype.$CONSTANTS = Constants;
Vue.prototype.$_ = _;
Vue.prototype.$instance = new Vue({
  store,
  router,
  i18n,
  vuetify: new Vuetify(),
  render: (h) => h(App),
}).$mount("#app");
